<template>
  <div class="cancel-predicted-transaction-summary">
    <popup :title="`האם למחוק את ה${transactionType} הקבועה הזו? `"
           :buttons="buttonOptions"
           :back-action="backAction">
      <template v-slot:content>
        <div class="text">המערכת לא תצפה את ה{{transactionType}}
          ב"{{ predictedTransaction.name }}" החודש ובחודשים הבאים.
        </div>
      </template>
    </popup>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import BaseUI from 'base-ui';
import Segment from '../../../../../../../../../../../Segment';

const INCOME_TEXT = 'הכנסה';
const EXPENSE_TEXT = 'הוצאה';

export default {
  name: 'CancelPredictionSummary',
  components: {
    Popup: BaseUI.Popup,
  },
  created() {
    Segment.trackUserInteraction('CancelPredictionSummary_Shown', {
      predictedTransaction: this.predictedTransaction,
    });
  },
  props: {
    predictedTransaction: {
      type: Object,
      required: true,
    },
    closeAction: {
      type: Function,
      required: true,
    },
    backAction: {
      type: Function,
      required: true,
    },
  },
  computed: {
    buttonOptions() {
      return [{
        title: 'כן, למחוק',
        action: this.onSave,
        variant: this.approveButtonVariant,
      }, {
        title: 'ביטול',
        action: this.closeAction,
        variant: 'secondary-black',
      }];
    },
    transactionType() {
      return this.isIncomeTransaction ? INCOME_TEXT : EXPENSE_TEXT;
    },
    approveButtonVariant() {
      return this.isIncomeTransaction ? 'success' : 'danger';
    },
    isIncomeTransaction() {
      return this.predictedTransaction.isIncome;
    },
  },
  methods: {
    ...mapActions('editCashflow', ['cancelEnvelope']),
    async onSave() {
      Segment.trackUserInteraction('CancelPredictionSummary_SaveClicked', {
        predictedTransaction: this.predictedTransaction,
      });
      this.closeAction();
      this.cancelEnvelope(this.predictedTransaction.envelopeId);
      const element = document.getElementsByClassName('cashflow-type-fixed');
      window.scroll({ top: element[0].offsetTop, left: 0, behavior: 'smooth' });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../../../../../../scss/category-color-mixins';

  .cancel-predicted-transaction-summary {
    .text {
      white-space: pre-line;
    }
  }

</style>
